module.exports = __webpack_public_path__ + "img/760-e40b18.png";